import { useNavigate } from "react-router-dom";
import { useState } from "react";

function RequestService() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    service: "",
    date: "",
    time: "",
    address: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const requests =
      JSON.parse(localStorage.getItem("mistribazaarRequests")) || [];

    requests.push(form);
    localStorage.setItem("mistribazaarRequests", JSON.stringify(requests));

    alert("Request submitted. Worker will be assigned shortly.");
    navigate("/");
  };

  return (
    <div
      style={{
        padding: "40px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "700px",
        margin: "0 auto",
      }}
    >
      <button
        onClick={() => navigate("/")}
        style={{
          marginBottom: "20px",
          padding: "10px 16px",
          border: "none",
          background: "black",
          color: "white",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        Back to Home
      </button>

      <h1>Request Service</h1>
      <p>Tell us what work you need. We will assign the best available professional.</p>

      <form onSubmit={handleSubmit}>
        <select
          value={form.service}
          onChange={(e) => setForm({ ...form, service: e.target.value })}
          required
          style={{
            width: "100%",
            padding: "12px",
            marginBottom: "12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
          }}
        >
          <option value="">Select Service</option>
          <option value="Plumber">Plumber</option>
          <option value="Electrician">Electrician</option>
          <option value="Carpenter">Carpenter</option>
          <option value="AC Repair">AC Repair</option>
          <option value="Labour">Labour</option>
          <option value="Mason / Mistri">Mason / Mistri</option>
          <option value="Painter">Painter</option>
          <option value="Tile Worker">Tile Worker</option>
          <option value="Welder">Welder</option>
          <option value="POP / False Ceiling Worker">POP / False Ceiling Worker</option>
          <option value="Bore / Pump Technician">Bore / Pump Technician</option>
          <option value="Rooftop / Waterproofing Worker">Rooftop / Waterproofing Worker</option>
          <option value="Fabricator">Fabricator</option>
          <option value="Aluminium Worker">Aluminium Worker</option>
          <option value="Glass Fitter">Glass Fitter</option>
          <option value="Modular Kitchen Installer">Modular Kitchen Installer</option>
          <option value="Door / Window Fitter">Door / Window Fitter</option>
          <option value="CCTV Technician">CCTV Technician</option>
          <option value="Solar Technician">Solar Technician</option>
          <option value="Helper">Helper</option>
        </select>

        <input
          type="date"
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
          required
          style={{
            width: "100%",
            padding: "12px",
            marginBottom: "12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
          }}
        />

        <input
          type="time"
          value={form.time}
          onChange={(e) => setForm({ ...form, time: e.target.value })}
          required
          style={{
            width: "100%",
            padding: "12px",
            marginBottom: "12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
          }}
        />

        <textarea
          placeholder="Enter full address"
          value={form.address}
          onChange={(e) => setForm({ ...form, address: e.target.value })}
          required
          rows="4"
          style={{
            width: "100%",
            padding: "12px",
            marginBottom: "12px",
            borderRadius: "8px",
            border: "1px solid #ccc",
          }}
        />

        <button
          type="submit"
          style={{
            padding: "12px 20px",
            border: "none",
            background: "black",
            color: "white",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Submit Request
        </button>
      </form>
    </div>
  );
}

export default RequestService;